import {AppState} from "../store";

export const getDispatchPageFilter = (state: AppState) => state.dispatchPage.filter
export const getDispatchPageState = (state: AppState) => state.dispatchPage.state
